<template>
  <el-collapse-item name="sshd">
    <template slot="title">
      SSH Server
      <el-tag v-if="form.sshd === '1'" type="success" size="small">ON</el-tag>
      <el-tag v-else type="info" size="small">OFF</el-tag>
    </template>

    <el-row :gutter="20">
      <el-col :span="5">
        <el-switch
          v-model="form.sshd"
          active-text="Enable"
          active-value="1"
          inactive-value="0"
          @change="changeDebounce"
        />
      </el-col>

      <el-col :span="19">
        <el-form class="connect">
          <el-input :value="publicIp" size="mini" class="host" readonly>
            <template slot="prepend">Host</template>
          </el-input>

          <el-input :value="username" size="mini" class="username" readonly>
            <template slot="prepend">User</template>
          </el-input>

          <el-input :value="port" size="mini" class="port" readonly>
            <template slot="prepend">Port</template>
          </el-input>
        </el-form>
      </el-col>
    </el-row>
  </el-collapse-item>
</template>

<script>
import config from '../../../../mixins/config'

export default {
  mixins: [config],
  props: {
    publicIp: String,
    username: String,
    port: Number
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  .connect {
    .el-input {
      margin-right: 10px;

      &.host {
        max-width: 210px;
      }
      &.username {
        max-width: 230px;
      }
      &.port {
        max-width: 130px;
      }
    }
  }
</style>
